import { Button, Modal } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';

export interface IConfirmModalProps {
  active: boolean;
  modalId: string;
  onClose: () => void;
  title: string;
  content: JSX.Element;
  confirmbutton: IConfirmModalButtonProps;
}

export interface IConfirmModalButtonProps {
  name: string;
  class: string;
  onClick: (e: any) => void;
}

export const ConfirmModal  = (props: IConfirmModalProps) => {
  const intl = useIntl();

  const handleClose = () => {
    console.log("closing");
    props.onClose();
  }

  return (
    <>
      <Modal id={props.modalId} show={props.active} onHide={handleClose}>

      <Modal.Header>
        <h2>{props.title}</h2>
        <button type="button" className="btn btn-link p-3" onClick={handleClose} aria-label={ intl.formatMessage({ id: 'button.close' })}>
          <i aria-hidden="true" role="presentation" className="fa fa-remove"></i>
        </button>
      </Modal.Header>

      <Modal.Body>
        {props.content}
      </Modal.Body>

      <Modal.Footer>
        
        <Button className="btn btn-secondary" onClick={handleClose}>
          <FormattedMessage id="button.close"/>
        </Button>
        <Button className={props.confirmbutton.class} onClick={props.confirmbutton.onClick}>
          {props.confirmbutton.name}
        </Button>
      </Modal.Footer>
      </Modal>

    </>
  );
}
